<template>
  <div class="modal-card confirm-modal">
    <div class="modal-header">
      <p class="modal-header-text">{{ $t('exchange.confirm_exchange') }}</p>
      <div
        class="modal-header-close-btn"
        @click="$parent.close()"
      >
        <img src="/static/svg/close-symbol.svg">
      </div>
    </div>
    <div class="modal-body">
      <div class="modal-content">
        <div class="modal-content-compare-rate">
          <div class="token-info">
            <div class="token-name-img">
              <img :src="`/static/token/normal/${source.code.toLowerCase()}.svg`">
            </div>
            <div class="token-name-lable">
              <div class="token-name-lable-code">
                {{ source.code }}
              </div>
              <div class="token-name-lable-fullname">
                {{ source.name }}
              </div>
              <div class="token-amount">
                {{ sourceAmount | numberWithComma }}
              </div>
            </div>
          </div>
          <div class="arrow">
            <img :src="`/static/svg/arrow-right.svg`">
          </div>
          <div class="token-info">
            <div class="token-name-img">
              <img :src="`/static/token/normal/${target.code.toLowerCase()}.svg`">
            </div>
            <div class="token-name-lable">
              <div class="token-name-lable-code">
                {{ target.code }}
              </div>
              <div class="token-name-lable-fullname">
                {{ target.name }}
              </div>
              <div class="token-amount">
                {{ targetAmount | numberWithComma }}
              </div>
            </div>
          </div>
        </div>
        <div class="token-rate">
          {{ $t('exchange.rate') }} 1 {{ source.code }} ~ {{ rate | numberWithComma }} {{ target.code }}
        </div>
        <div class="gas-info is-mobile-margin">
          <div class="is-expanded gas-info-row">
            <div class="gas-info-row-left">
              <img
                src="/static/svg/icon-minimum-rate-black.svg"
                class="gas-info-row-left-ic"
              >
              {{ $t('exchange.max_rate_change') }}
            </div>
            <div class="gas-info-row-right">
              {{ maxPriceSlippage }}%
            </div>
            <div>
              <b-tooltip
                :label="$t('exchange.max_slippage_detail')"
                type="is-light"
                class="icon-info"
              >
                <img
                  src="/static/svg/exchange-info.svg"
                  class="tootip-img"
                >
              </b-tooltip>
            </div>
          </div>
          <div class="is-expanded gas-info-row">
            <div class="gas-info-row-left">
              <img
                src="/static/svg/icon-transaction-fee-black.svg"
                class="gas-info-row-left-ic"
              >
              {{ $t('exchange.network_fee') }}
            </div>
            <div class="gas-info-row-right">
              ~ {{ txFee | numberWithComma }} ETH
            </div>
            <div>
              <b-tooltip
                :label="$t('exchange.network_fee_detail')"
                type="is-light"
                class="icon-info"
              >
                <img
                  src="/static/svg/exchange-info.svg"
                  class="tootip-img"
                >
              </b-tooltip>
            </div>
          </div>
          <div class="is-expanded gas-info-row">
            <div class="gas-info-row-left">
              <img
                src="/static/svg/icon-estimate-time-black.svg"
                class="gas-info-row-left-ic"
              >
              {{ $t('exchange.estimate_time') }}
            </div>
            <div class="gas-info-row-right">
              &#60; {{ estimatedTime }} {{ $t('exchange.minutes') }}
            </div>
          </div>
          <div class="is-expanded gas-info-row">
            <div class="gas-info-row-left">
              <img
                src="/static/svg/icon-platform-fee-black.svg"
                class="gas-info-row-left-ic"
              >
              {{ $t('exchange.platform_fee') }}
            </div>
            <div class="gas-info-row-right">
              {{ platformFee | numberWithComma(3) }} %
            </div>
            <div>
              <b-tooltip
                :label="$t('exchange.platform_fee_detail')"
                type="is-light"
                class="icon-info"
              >
                <img
                  src="/static/svg/exchange-info.svg"
                  class="tootip-img"
                >
              </b-tooltip>
            </div>
          </div>
          <div class="notice is-mobile-margin">
            <div class="notice-header">
              <img src="/static/svg/warning.svg">
              <span class="notic-header-text">
                {{ $t('exchange.gas_price_notice') }}
              </span>
            </div>
            <div class="notice-content">
              {{ $t('exchange.gas_price_notice_detail') }}
            </div>
            <p class="kulap-smart-contract--title">
              KULAP Smart Contract Address
            </p>
            <div class="kulap-smart-contract--addr">
              <a
                :href="`${etherScanUrl}/address/${kulapSmartContractAddr}`"
                target="_blank"
              >
                {{ shortAddr }}
                <img
                  v-if="shortAddr.length > 0"
                  src="/static/svg/open-new-tab-blue.svg"
                >
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="button cancle-btn"
        @click="$parent.close()"
      >
        {{ $t('messages.close') }}
      </button>
      <button
        class="button confirm-btn"
        @click="confirm()"
      >
        {{ $t('exchange.confirm') }}
      </button>
    </div>
  </div>
</template>

<script>
import bignumber from '@/utils/bignumber'

export default {
  props: {
    source: {
      type: Object,
      default: () => {}
    },
    target: {
      type: Object,
      default: () => {}
    },
    sourceAmount: {
      type: Object,
      default: () => {}
    },
    targetAmount: {
      type: Object,
      default: () => {}
    },
    gasPrice: {
      type: Object,
      default: () => {}
    },
    txFee: {
      type: Object,
      default: () => {}
    },
    platformFee: {
      type: [String, Number],
      default: 0
    },
    estimatedTime: {
      type: [Number, String],
      required: true
    },
    maxPriceSlippage: {
      type: Number,
      default: 1
    },
    kulapSmartContractAddr: {
      type: String,
      default: ''
    },
    etherScanUrl: {
      type: String,
      default: 'https://etherscan.io'
    }
  },
  computed: {
    rate () {
      return bignumber(this.targetAmount).div(bignumber(this.sourceAmount))
    },
    shortAddr () {
      if (this.kulapSmartContractAddr) {
        const first = this.kulapSmartContractAddr.substr(0, 12)
        const last = this.kulapSmartContractAddr.substr(this.kulapSmartContractAddr.length - 12, this.kulapSmartContractAddr.length)
        return `${first}...${last}`
      } else {
        return ''
      }
    }
  },
  methods: {
    confirm () {
      this.$emit('onConfirm')
      this.$parent.close()
    },
    addrSplited () {
      if (this.userDefaultWallet) {
        const first = this.userDefaultWallet.substr(0, 10)
        const last = this.userDefaultWallet.substr(37, this.userDefaultWallet.length)
        return `${first}...${last}`
      }
      return ''
    }
  }
}
</script>
<style scoped lang="scss">
.confirm-modal {
  float: left;
  width: 530px;
  background-color: #ffffff;
  border-radius: 5px;
}
.modal-header {
  float: left;
  width: 100%;
  height: 62px;
  background-color: #0559af;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-header-text {
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.7px;
  color: #ffffff;
}
.modal-header-close-btn {
  position: absolute;
  top: 15px;
  right: 19px;
}
.modal-header-close-btn:hover {
  cursor: pointer;
}
.modal-body {
  float: left;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: scroll;
}
.modal-content {
  width: 100%;
  float: left;
  padding: 40px 60px;
}
.modal-content-compare-rate {
  width: 100%;
  float: left;
}
.token-info{
  float: left;
  width: 35%;
  padding: 0px 15px;
}
.token-name-img {
  float: left;
  height: 40px;
  width: 40px;
  padding: 5px;
}
.token-name-lable {
  float: left;
  margin-left: 10px;
  width: calc(100% - 50px);
}
.token-name-lable-fullname {
  font-family: Roboto;
  font-size: 13px;
  font-weight: 300;
  color: #646464;
}
.token-name-lable-code {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  color: #333333;
}
.token-amount {
  float: left;
  font-family: DINAlternate !important;
  font-size: 17px;
  color: #363636;
  margin-top: 10px;
  max-width: 100%;
}
.token-rate {
  font-family: DINAlternate !important;
  font-size: 12px;
  color: #7d7d7d;
  margin-top: 15px;
  float: right;
}
.arrow {
  float: left;
  width: 30%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.gas-info {
  float: left;
  width: 100%;
  margin-top: 50px;
  padding: 0 5%;
}
.gas-info-row {
  font-size: 13px;
  border-bottom: solid 1px #e6e6e6;
  padding-top: 10px;
  padding-bottom: 10px;
}
.gas-info-row-left {
  float: left;
  display: flex;
  align-items: center;
}
.gas-info-row-left-ic {
  margin-right: 5px;
}
.gas-info-row-right {
  float: right;
  font-weight: bold;
}
.notice {
  float: left;
  width: 100%;
  margin-top: 15px;
}
.notice-header {
  float: left;
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.notic-header-text {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  color: #4a4a4a;
  margin-left: 10px;
}
.notice-content {
  float: left;
  width: 100%;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  color: #4a4a4a;
  margin: 20px 10px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.kulap-smart-contract {
  &--title {
    float: left;
    width: 100%;
    font-family: Roboto;
    font-size: 12px;
    font-weight: 500;
    color: #4a4a4a;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  &--addr {
    float: left;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: #0564c4;
    font-size: 12px;
    margin-top: 5px;
  }
}
.modal-footer {
  float: left;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-top: 3px solid #dfdfdf;
  height: 70px;
  padding: 0 20px;
}
.confirm-btn {
  width: 108px;
  height: 40px;
  border-radius: 2px;
  border: 0px;
  background-color: #2193ff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  margin-left: 5px;
  font-family: Roboto;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.4px;
  color: #ffffff;
}
.cancle-btn {
  width: 108px;
  height: 40px;
  border: 0px;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.4px;
  color: #2193ff;
}
.tootip-img {
  margin-left: 5px;
  margin-top: 3px;
}
@media only screen and (max-width: 768px) {
  .confirm-modal {
    width: 100%;
    /* height: 530px; */
  }
  .modal-content {
    padding: 40px 0px;
    margin: 10px 0;
  }
  .token-info {
    text-align: center;
    width: 45%;
  }
  .arrow {
    width: 10%;
  }
  .token-name-img {
    width: 40px;
    height: 40px;
    margin: 0 auto;
    float: none;
  }
  .token-amount {
    text-align: center;
    float: left;
    width: 100%;
  }
  .token-name-lable {
    margin-top: 5px;
    width: 100%;
    margin-left: 0px
  }
  .token-rate {
    float: left;
    width: 100%;
    text-align: center;
  }
  .is-mobile-margin {
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ConfirmModal.vue